import { render, staticRenderFns } from "./Daze.vue?vue&type=template&id=8ff34bf4&"
import script from "./Daze.vue?vue&type=script&lang=js&"
export * from "./Daze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports